declare global {
  interface Window {
    dataLayer?: unknown[][]
    gtag?: (...args: unknown[]) => void
  }
}

const trackedTools = new Set([
  'open-pdf',
  'add-pdf',
  'save',
  'undo',
  'redo',
  'zoom-out',
  'zoom-in',
  'rotate-left',
  'rotate-right',
  'delete',
  'select-mode',
  'text-mode',
  'insert-tick',
  'insert-cross',
  'markup-highlight',
  'markup-freehand',
  'markup-arrow',
  'markup-duplicate',
  'markup-rotate',
  'markup-delete',
  'insert-image',
  'signature',
  'search',
])

export function trackToolUsage(
  tool: string,
  interactionMethod: 'toolbar' | 'keyboard' | 'file-picker' = 'toolbar',
): void {
  if (!trackedTools.has(tool)) return
  window.gtag?.('event', 'tool_use', {
    tool_name: tool,
    interaction_method: interactionMethod,
  })
}
